import { getPropertiesNonAdminsCanEdit } from "api/services/programService";
import { selector } from "recoil";

export const propertiesNonAdminsCanUpdateOnActivePrograms = selector({
  key: "propertiesNonAdminsCanUpdateOnActivePrograms",
  get: async ({}) => {
    const props = await getPropertiesNonAdminsCanEdit();

    const nonAdminPropsLookup: Record<string, boolean> = {};

    props.map(x => (nonAdminPropsLookup[x.toLowerCase()] = true));

    return nonAdminPropsLookup;
  }
});
